import Typography from "antd/es/typography/Typography";

const { Paragraph } = Typography;

const VerboseCarousel = (props) => {
  const { img, uid, urlLogo, sumup, children } = props;

  return (
    <div
      id={`${uid}`}
      style={{
        borderRadius: 10,
        overflow: "hidden",
        backgroundColor: "white",
        width: 325,
        maxWidth: 325,
        minWidth: 325,
      }}
    >
      <div
        style={{
          width: "100%",
          aspectRatio: 1604 / 740,
          backgroundImage: `url(${img})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        {children}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          style={{
            height: 50,
            aspectRatio: 1,
            margin: 10,
            borderRadius: 10,
          }}
          src={urlLogo}
          alt=""
        />
        <Paragraph
          style={{
            marginLeft: 10,
            marginRight: 10,
          }}
          ellipsis
        >
          {sumup}
        </Paragraph>
      </div>
    </div>
  );
};

export default VerboseCarousel;
